import * as download from 'downloadjs';

import { ResponseTypes, sendRequestWithAuth } from '../common/sendRequest';
import * as settings from './settings';
import { getFavoritesRequestParams } from '../common/favoritesServiceHelper';

export function getOfflineLicenses() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_full_offline_licenses'
      })
    }
  );
}

export function getOfflineLicenseById(offlineLicenseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_offline_license_by_id',
        id: offlineLicenseId,
      })
    }
  );
}

export function createNewOfflineLicense(
  clientId, productName, type, deviceKey,
  activationDate = null, supportDayCount = null, connectionCount = null, webConnectionCount = null, webValidityTerm = null, dicomConnectionLimitationType) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'create_new_offline_License',
        product_name: productName,
        type,
        device_key: deviceKey,
        client_id: clientId,
        activation_date: activationDate,
        support_day_count: supportDayCount,
        connection_count: connectionCount,
        web_connection_count: webConnectionCount,
        web_validity_term: webValidityTerm,
        dicom_connection_limitation_type: dicomConnectionLimitationType,
      })
    }
  );
}

export function getOfflineLicLivingStates() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_offline_license_living_states'
      })
    }
  );
}

export function removeOfflineLicenses(licenseIds = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'remove_offline_licenses',
        license_ids: licenseIds
      })
    }
  );
}

export function restoreOfflineLicenses(licenseIds = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'restore_offline_licenses',
        license_ids: licenseIds
      })
    }
  );
}

export function getOfflineLicenseHistory(licenseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_offline_license_history',
        license_id: licenseId
      })
    }
  );
}

export function downloadLicense(licenseId = null) {
  return sendRequestWithAuth(
    `${settings.ServerURL}?operation=get_offline_license_file&license_id=${licenseId}`, {
      method: 'GET'
    }, ResponseTypes.file
  ).then(file => download(file.data, file.name));
}

export function getOfflineLicenseHistoryById(licenseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_offline_license_history_by_id',
        id: licenseId
      })
    }
  );
}

export function updateOfflineLicense(id, supportDayCount, webConnectionCount, connectionCount, webValidityTerm = null, dicomConnectionLimitationType, deviceKey) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'update_offline_license',
        id,
        support_day_count: supportDayCount,
        web_connection_count: webConnectionCount,
        connection_count: connectionCount,
        web_validity_day_count: webValidityTerm,
        dicom_connection_limitation_type: dicomConnectionLimitationType,
        device_key: deviceKey
      })
    }
  );
}

export function addOfflineLicenseToFavorites(licenseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, getFavoritesRequestParams(
      'offline_license', 'add', licenseId
    )
  );
}

export function removeOfflineLicenseFromFavorites(licenseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, getFavoritesRequestParams(
      'offline_license', 'remove', licenseId
    )
  );
}

export function getDicomLimitTypes() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_dicom_connection_limitation_types',
      })
    }
  );
}



// WEBPACK FOOTER //
// ./src/services/offlineLicenses.js